// eslint-disable-next-line no-restricted-imports
import {
  AmountWithValueAndCurrency,
  MutationInput_LegalClientBeneficiaryController_UpdateById_Input_ControlOverLegalClientStatus,
  Query_LegalClientBeneficiaryController_GetById_ControlOverLegalClientStatus,
  Query_LegalClientBeneficiaryController_GetSnapshot_Value_ControlOverLegalClientStatus,
} from 'api/generated/graphql';
import { parseAmount } from 'api/helpers/parseEntity/parseAmount';
import {
  ControlOverEntity,
  ControlOverLegalClientStatusType,
} from 'api/types/entity';

interface ParseControlOverEntityParams {
  financialConditionAmount?: AmountWithValueAndCurrency | null;
  directCapitalParticipationPercentage?: number | null;
  hasControlOverLegalClient?: boolean | null;
  indirectCapitalParticipationPercentage?: number | null;
  controlOverLegalClientStatus?:
    | Query_LegalClientBeneficiaryController_GetById_ControlOverLegalClientStatus
    | MutationInput_LegalClientBeneficiaryController_UpdateById_Input_ControlOverLegalClientStatus
    | Query_LegalClientBeneficiaryController_GetSnapshot_Value_ControlOverLegalClientStatus
    | null;
}

export const parseControlOverEntity = (
  data: ParseControlOverEntityParams
): ControlOverEntity | undefined => {
  if (typeof data.directCapitalParticipationPercentage !== 'number')
    return undefined;

  return {
    directCapitalParticipationPercentage:
      data.directCapitalParticipationPercentage!,
    financialConditionAmount: data.financialConditionAmount
      ? parseAmount(data.financialConditionAmount)
      : undefined,
    hasControlOverLegalClient: data.hasControlOverLegalClient ?? undefined,
    indirectCapitalParticipationPercentage:
      data.indirectCapitalParticipationPercentage ?? undefined,
    controlOverLegalClientStatus: data.controlOverLegalClientStatus
      ? ControlOverLegalClientStatusType[data.controlOverLegalClientStatus]
      : undefined,
  };
};
